'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../../utils');

var _nitroRipple = require('../nitro-ripple');

var _nitroRipple2 = _interopRequireDefault(_nitroRipple);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NitroCheckbox = function (_Component) {
  _inherits(NitroCheckbox, _Component);

  function NitroCheckbox(props) {
    _classCallCheck(this, NitroCheckbox);

    var _this = _possibleConstructorReturn(this, (NitroCheckbox.__proto__ || Object.getPrototypeOf(NitroCheckbox)).call(this, props));

    _this.handleChange = function (event) {
      if (_this.props.disabled) return;
      var switched = !_this.state.switched;
      _this.setState({
        switched: switched
      });

      if (typeof _this.props.action === 'function') {
        _this.props.action(event, switched);
      }
    };

    var checked = props.checked,
        defaultChecked = props.defaultChecked,
        valueLink = props.valueLink;


    _this.state = {
      switched: Boolean(checked || defaultChecked || valueLink && valueLink.value)
    };
    return _this;
  }

  _createClass(NitroCheckbox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.checked === 'boolean' && this.state.switched !== nextProps.checked) {
        this.setState({
          switched: nextProps.checked
        });
      }
    }
  }, {
    key: 'isChecked',
    value: function isChecked() {
      return this.state.switched;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          checkboxPosition = _props.checkboxPosition,
          className = _props.className,
          disabled = _props.disabled,
          disableRipple = _props.disableRipple,
          fullWidth = _props.fullWidth,
          label = _props.label,
          labelPosition = _props.labelPosition,
          labelVariant = _props.labelVariant,
          maxWidth = _props.maxWidth,
          rippleScaleInitial = _props.rippleScaleInitial,
          rippleScaleFinal = _props.rippleScaleFinal,
          size = _props.size,
          tickVariant = _props.tickVariant,
          variant = _props.variant,
          wrapText = _props.wrapText;


      var checked = this.state.switched;

      var labelElement = _react2.default.createElement(
        _styles.CheckboxLabel,
        {
          variant: variant,
          checked: checked,
          wrapText: wrapText,
          labelVariant: labelVariant,
          disabled: disabled
        },
        label
      );

      return _react2.default.createElement(
        _styles.CheckboxWrapper,
        {
          className: className,
          disabled: disabled,
          maxWidth: maxWidth,
          onClick: this.handleChange
        },
        _react2.default.createElement(
          _styles.CheckboxLabelWrapper,
          {
            fullWidth: fullWidth,
            disabled: disabled
          },
          labelPosition === 'left' && labelElement,
          _react2.default.createElement(_styles.CheckboxInput, {
            checked: checked,
            className: 'checkbox',
            disabled: disabled
            //onChange={this.handleChange}
            , type: 'checkbox'
          }),
          _react2.default.createElement(
            _styles.CheckboxBox,
            {
              checkboxPosition: checkboxPosition,
              checked: checked,
              disabled: disabled,
              labelPosition: labelPosition,
              size: size,
              variant: variant,
              tickVariant: tickVariant
            },
            !disableRipple && _react2.default.createElement(_nitroRipple2.default, {
              scaleInitial: rippleScaleInitial,
              scaleFinal: rippleScaleFinal,
              ref: function ref(c) {
                _this2.ripple = c;
              },
              variant: checked ? variant : 'base2'
            })
          ),
          labelPosition === 'right' && labelElement
        ),
        disabled && _react2.default.createElement(_utils.DisableCover, null)
      );
    }
  }]);

  return NitroCheckbox;
}(_react.Component);

NitroCheckbox.propTypes = {
  action: _propTypes2.default.func,
  checkboxPosition: _propTypes2.default.oneOf(['top', 'center', 'bottom']),
  checked: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  defaultChecked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  disableRipple: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  labelVariant: _propTypes2.default.string,
  maxWidth: _propTypes2.default.string,
  rippleScaleInitial: _propTypes2.default.number,
  rippleScaleFinal: _propTypes2.default.number,
  size: _propTypes2.default.number,
  tickVariant: _propTypes2.default.string,
  variant: _propTypes2.default.string,
  wrapText: _propTypes2.default.bool
};

NitroCheckbox.defaultProps = {
  checkboxPosition: 'center',
  labelPosition: 'right',
  maxWidth: '250px',
  size: 24,
  tickVariant: 'white',
  variant: 'secondary'
};

exports.default = NitroCheckbox;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-checkbox/NitroCheckbox.js
// module id = 2894
// module chunks = 4